/**
 * Shop Configuration Map
 *
 * Central source of truth for all shop-specific values.
 * The active shop is determined by window.location.hostname.
 */

const shops = {
  de: {
    key: "de",
    domain: "picmondoo.de",
    currency: "€",
    shopifyDomain: "picmondoo.myshopify.com",
    apiKey: "40a4d90f0da706f03c1bc4e747628e85",
    apiPassword: "16256bf9b99e7ce75b5e952a29db1024",
    apiVersion: "2024-01",
    hasMnZ: true,
    diamondPaintingProductId: 8341420540169,
    optionKeys: {
      size: "Größe",
      stoneShape: "Steinform",
      frame: "Rahmen",
      color: "Farbe",
    },
    stoneSquareValue: "Quadratisch",
    productUrls: {
      diamondPainting: [
        "https://picmondoo.de/products/diamond-painting-eigenes-bild-oder-foto.json",
        "https://picmondoo.de/products/diamond-painting-eigenes-bild-oder-foto.json",
      ],
      malenNachZahlen: [
        "https://picmondoo.de/products/malen-nach-zahlen-eigenes-bild.json",
      ],
    },
    extrasUrls: [
      "https://picmondoo.de/products/mehr-farben-fur-personalisierte-diamond-paintings.json",
      "https://picmondoo.de/products/glitzersteine-ab-fur-personalisierte-diamond-paintings.json",
      "https://picmondoo.de/products/leuchtsteine-fur-personalisierte-diamond-paintings.json",
      "https://picmondoo.de/products/feenstaubeffekt.json",
      "https://picmondoo.de/products/metalliceffekt.json",
      "https://picmondoo.de/products/strasseffekt.json",
    ],
    extras2Urls: [
      "https://picmondoo.de/products/profidatencheck.json",
      //"https://picmondoo.de/products/equipment-set.json",
      "https://picmondoo.de/products/farbtabelle-als-aufkleber.json",
      "https://picmondoo.de/products/cover-minder-personalisiert.json",
      "https://picmondoo.de/products/aufkleber-5er-set.json",
      "https://picmondoo.de/products/bevorzugte-produktion.json",
      "https://picmondoo.de/products/geschenkverpackung-1.json",
      "https://picmondoo.de/products/diamond-painting-bilderrahmen-schwarz-6-grossen-plexi.json",
    ],
    cartUrl: "https://picmondoo.de/cart/add.js",
    redirectUrl: "https://www.picmondoo.de",
    pageBaseUrl: "https://picmondoo.de/pages/dein-eigenes-foto",
    stockProxyUrl: "https://querytag.de/projekte/picmondoo/shopify/?id=",
  },
  intl: {
    key: "intl",
    domain: "picmondoo.com",
    currency: "$",
    shopifyDomain: "picmondoo-english.myshopify.com",
    apiKey: "72568ae5cf06ad243aba8d8cda819c5a",
    apiPassword: "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",
    apiVersion: "2024-01",
    hasMnZ: false,
    diamondPaintingProductId: 10423290167629,
    optionKeys: {
      size: "Size",
      stoneShape: "Stone shape",
      frame: "Frame",
      color: "Color",
    },
    stoneSquareValue: "square",
    productUrls: {
      diamondPainting: [
        "https://picmondoo-english.myshopify.com/products/diamond-painting-custom-image.json",
        "https://picmondoo-english.myshopify.com/products/diamond-painting-custom-image.json",
      ],
      malenNachZahlen: [],
    },
    extrasUrls: [
      //"https://picmondoo.de/products/mehr-farben-fur-personalisierte-diamond-paintings.json",
      "https://picmondoo.com/products/glitter-effect.json",
      //"https://picmondoo.de/products/leuchtsteine-fur-personalisierte-diamond-paintings.json",
      "https://picmondoo.com/products/fairy-dust-effect.json",
      "https://picmondoo.com/products/metallic-effect.json",
      "https://picmondoo.com/products/rhinestone-effect.json",
    ],
    extras2Urls: [
      "https://picmondoo.com/products/professional-data-check.json",
      //"https://picmondoo.de/products/equipment-set.json",
      //"https://picmondoo.de/products/farbtabelle-als-aufkleber.json",
      "https://picmondoo.com/products/cover-minder.json",
      //"https://picmondoo.de/products/aufkleber-5er-set.json",
      "https://picmondoo.com/products/priority-production.json",
      //"https://picmondoo.de/products/geschenkverpackung-1.json",
      //"https://picmondoo.de/products/diamond-painting-bilderrahmen-schwarz-6-grossen-plexi.json",
    ],
    cartUrl: "https://picmondoo.com/cart/add.js",
    redirectUrl: "https://picmondoo.com",
    pageBaseUrl: "https://picmondoo.com/pages/custom-image",
    stockProxyUrl: "",
  },
};

const DEFAULT_SHOP = "de";
const HOSTNAME_SHOP_MAP = {
  "picmondoo.de": "de",
  "www.picmondoo.de": "de",
  "picmondoo.com": "intl",
  "www.picmondoo.com": "intl",
};

/**
 * Resolve the shop key by matching a product ID against all shops'
 * diamondPaintingProductId. Falls back to DEFAULT_SHOP if no match.
 */
export function resolveShopKeyByProductId(productId) {
  if (!productId) return DEFAULT_SHOP;
  const id = Number(productId);
  for (const [key, config] of Object.entries(shops)) {
    if (config.diamondPaintingProductId === id) {
      return key;
    }
  }
  return DEFAULT_SHOP;
}

/**
 * Get the config object for a given shop key.
 */
export function getShopConfig(key) {
  return shops[key] || shops[DEFAULT_SHOP];
}

/**
 * Resolve the shop key from a hostname.
 */
export function resolveShopKeyByHostname(hostname) {
  if (!hostname) return DEFAULT_SHOP;
  return HOSTNAME_SHOP_MAP[hostname.toLowerCase()] || DEFAULT_SHOP;
}

/**
 * Get the shop key for the currently active hostname.
 */
export function getCurrentShopKey() {
  if (typeof window === "undefined") return DEFAULT_SHOP;
  return resolveShopKeyByHostname(window.location.hostname);
}

/**
 * Get the config for the currently active shop (from hostname).
 */
export function getCurrentShopConfig() {
  return getShopConfig(getCurrentShopKey());
}

export { shops, DEFAULT_SHOP, HOSTNAME_SHOP_MAP };
